export const HTTP_DEFAULTS = {
  HOST: '0.0.0.0',
  PORT: 3000,
} as const;

export const DEFAULT_METHODS = ['GET', 'POST', 'PUT', 'PATCH', 'DELETE', 'OPTIONS'];
export const DEFAULT_HEADERS = ['Content-Type', 'Authorization', 'X-Api-Key'];
